import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/Card'

export const ChatInterface: React.FC = () => {
  return (
    <div className="h-screen bg-gray-50 p-4">
      <Card className="h-full">
        <CardHeader>
          <CardTitle>Chat Interface</CardTitle>
          <CardDescription>Interactive chat with your AI chatbot</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">Chat interface will be implemented here</p>
        </CardContent>
      </Card>
    </div>
  )
}